import React from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBack, arrowBackCircle, bookmark } from 'ionicons/icons';
import { Backbutton, Bookmarkbutton, TopNavContainer } from './InnerPageStyles';
import { useHistory } from 'react-router';
import BookmarkTrailButton from '../BookmarkButton/BookmarkTrailButton';

type TopNavProps = {
	trailId: number;
};
const TrailTopNav: React.FC<TopNavProps> = ({ trailId }) => {
	const history = useHistory();
	return (
		<TopNavContainer>
			<Backbutton>
				<IonIcon
					icon={arrowBack}
					onClick={() => {
						if (window.history.length > 1) {
							history.goBack();
						} else {
							history.replace('/home');
						}
					}}
				/>
			</Backbutton>
			<BookmarkTrailButton trailId={trailId} />
		</TopNavContainer>
	);
};

export default TrailTopNav;
